import { Link, useNavigate, useParams } from "react-router";
import { useEffect, useRef, useState } from "react";
import ActiveTabIndicator from "../../components/ActiveTabIndicator";
import PendingContracts from "./PendingContracts";
import Claim from "./Claim";
import Contracts from "./Contracts";

const tabButtons = [
  {
    name: "Contracts",
    path: "/contracts",
  },
  {
    name: "Pending Contracts",
    path: "/pending-contracts",
  },
  {
    name: "Claims",
    path: "/claims",
  },
];

function PoDealer() {
  const tabsRef = useRef<Record<any, HTMLAnchorElement | null>>({});
  const navigate = useNavigate();
  const { activeTab = "" } = useParams();
  const [activeTabName, setActiveTabName] = useState("");

  useEffect(() => {
    const cleanTab = tabButtons.find(
      (tab) => tab.path.toLowerCase() === `/${activeTab.toLowerCase()}`
    );
    if (cleanTab) {
      setActiveTabName(cleanTab.name);
    } else {
      navigate("/contracts");
    }
  }, [activeTab, navigate]);

  return (
    <>
      <div className="container">
        <div className="sm:pt-9 pt-6 pb-3 min-[720px]:flex grid items-center gap-4">
          <div className="relative flex max-[400px]:gap-4 gap-6 border-b border-gray-300 flex-1">
            {tabButtons.map((item, index) => (
              <Link
                to={item.path}
                ref={(ref) => {
                  tabsRef.current[item.name] = ref;
                }}
                key={index}
                onClick={() => setActiveTabName(item.name)}
                className={`pb-1 font-medium ${
                  activeTabName === item.name
                    ? "text-black"
                    : "text-gray-500 hover:text-black"
                }`}
              >
                {item.name}
              </Link>
            ))}
            <ActiveTabIndicator
              allTabRefs={tabsRef}
              currentTab={activeTabName}
            />
          </div>
        </div>
      </div>
      {activeTabName === "Pending Contracts" && <PendingContracts />}
      {activeTabName === "Contracts" && <Contracts />}
      {activeTabName === "Claims" && <Claim />}
    </>
  );
}

export default PoDealer;
